import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-male-chair-tai-chi',
	options: {
		userFlags: ['hasAccessToYogaVideos'],
		userTags: ['tai_chi_chair_yoga'],
	},
	landing: {
		ids: ['loader-chair-tai-chi-m', 'age-chair-tai-chi-m'],
		route: {
			path: '/chair-tai-chi-m',
			name: 'male-chair-tai-chi-funnel',
		},
	},
	funnel: {
		id: 'ob-male-tai-chi-chair-workouts',
		route: {
			path: '/chair-tai-chi-m/ob/:page(.*)?',
			name: 'activity-male-chair-tai-chi',
		},
		slug: 'activity-male-chair-tai-chi',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-chair-tai-chi-m',
	},
	upsell: {
		routeNames: ['upsell-activity-m'],
		overrides: [],
	},
}

export default appAreaConfig
